import { Timeline, Group, Badge, Stack, ScrollArea } from "@mantine/core";
import { ThoughtProcessData } from "../types";
import { CodeHighlight } from "@mantine/code-highlight";
import { TokenUsageGraph } from "../analysis/TokenUsageGraph";
import type { TokenUsageProps } from "../../api";

export interface ThoughtProcessProps {
    data: ThoughtProcessData[];
}

export const ThoughtProcess = ({ data }: ThoughtProcessProps) => {
    return (
        <Timeline bulletSize={20} lineWidth={3}>
            {data.map((t, index) => (
                <Timeline.Item title={t.title} key={index}>
                    <Stack gap="md">
                        {t.props && (
                            <Group gap="xs">
                                {(Object.keys(t.props).filter(k => k !== "token_usage" && k !== "query_plan") || []).map((k: any) => (
                                    <Badge variant="light" color="blue" size="lg" radius="sm">
                                        {k}: {JSON.stringify(t.props?.[k])}
                                    </Badge>
                                ))}
                            </Group>
                        )}
                        {/* Thought props are free-form; the backend puts its TokenUsageProps under token_usage. */}
                        {t.props?.token_usage ? (
                            <TokenUsageGraph
                                tokenUsage={t.props.token_usage as TokenUsageProps}
                                reasoningEffort={typeof t.props.reasoning_effort === "string" ? t.props.reasoning_effort : undefined}
                            />
                        ) : null}
                        <ScrollArea.Autosize mah={400}>
                            <CodeHighlight
                                code={JSON.stringify(t.description, null, 2) ?? ""}
                                language="json"
                                copyLabel="Copy button code"
                                copiedLabel="Copied!"
                            />
                        </ScrollArea.Autosize>
                    </Stack>
                </Timeline.Item>
            ))}
        </Timeline>
    );
};
